import React from 'react'
import { connect } from 'react-redux'

import { withAuthorization, AuthUserContext } from './Session'
import {
  selectedContent,
  selectedContentNode,
  selectedFolder,
} from '../selectors'

import TopBar from './TopBar'
import SidePanel from './SidePanel'
import ContentPanel from './ContentPanel'
import NodeContent from '../nodes/NodeContent'

class HomePage extends React.Component {
  componentDidMount() {
    window.addEventListener('dragover', this.onDragDrop)
    window.addEventListener('drop', this.onDragDrop)
  }

  componentWillUnmount() {
    window.removeEventListener('dragover', this.onDragDrop)
    window.removeEventListener('drop', this.onDragDrop)
  }

  onDragDrop = (event) => {
    event.preventDefault()
  }

  render() {
    const {
      isReceived,
      contentId,
      content,
      onClickSignOut,
      selectedContentNode,
      firebase,
      selectedFolder,
    } = this.props
    return (
      <AuthUserContext.Consumer>
        {(authUser) => (
          <div className="homePage">
            <TopBar
              {...this.props}
              firebase={firebase}
              isViewOnly={isReceived}
            />
            <SidePanel user={authUser} onClickSignOut={onClickSignOut} />
            {content && (
              <ContentPanel
                contentId={contentId}
                isViewOnly={isReceived}
                selectedFolder={selectedFolder}
              />
            )}
            {selectedContentNode && (
              <NodeContent node={selectedContentNode} isViewOnly={isReceived} />
            )}
          </div>
        )}
      </AuthUserContext.Consumer>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { receivedContentCollection } = state
  return {
    content: selectedContent(state),
    isReceived: receivedContentCollection.hasOwnProperty(
      state.app.selectedContentId,
    ),
    loading: state.app.loading,
    contentId: state.app.selectedContentId,
    selectedFolder: selectedFolder(state),
    selectedContentNode: selectedContentNode(state),
  }
}

const ConnectedHomePage = connect(mapStateToProps)(HomePage)

const condition = (authUser) => !!authUser

export default withAuthorization(condition)(ConnectedHomePage)
